<script lang="ts" context="module">
  import { getAppConfig } from '../../../../../common/config/app-config';
  import { CONSTANTS } from '../../../../../common/config/constants';

  import {
    getJoodExpiredMembershipType,
    getJoodMembershipType,
    getStr,
    globalCurrencyTag,
    roundToNDigits,
    type JoodMembershipType,
  } from '../../../../../common/util';

  import { getJoodDayBannerDetails } from '../../../../../common/joodUtils';

  const { extraThemeResourcePath, joodExpiredFlag, lang, encodedContextPath, primeLevel } = getAppConfig();

  const expiredJoodMembershipType = getJoodExpiredMembershipType();
  const { NOPRIME } = CONSTANTS;
</script>

<script lang="ts">
  import { getpdpJoodBenefitInfo } from '../../../../product-details/services/pdp-data-services';
  import {
    openPdpJoodBenefitInfoPopup,
    pdpJoodBenefitInfo,
    pdpProductPrice,
  } from '../../../../product-details/store/pdp_store';
  import { ProductTilePriceGroupVariantType } from '../product-tile-main';
  import JoodExpireWallet from './JoodExpireWallet.svelte';

  export let priceType: JoodMembershipType = NOPRIME;
  export let creditPoints;
  export let variant: ProductTilePriceGroupVariantType;
  export let theme = null;
  export let isTacticalFlag = true;
  let userJoodMembershipType = expiredJoodMembershipType || getJoodMembershipType();

  // $: hasBGSet = !!theme?.cashpointBackgroundImage;
  let bgImageMap = {
    NOPRIME: `${extraThemeResourcePath}/images/jood/wallet/service-vip.svg`,
    BASICPRIME: `${extraThemeResourcePath}/images/jood/wallet/service-basic.svg`,
    SMARTPRIME: `${extraThemeResourcePath}/images/jood/wallet/service-smart.svg`,
    VIPPRIME: `${extraThemeResourcePath}/images/jood/wallet/service-vip.svg`,
  };
  $: bgImage = bgImageMap[userJoodMembershipType] ? `url(${bgImageMap[userJoodMembershipType]})` : null;
  // $: bgColor = hasBGSet && !theme?.cashpointBackgroundImage.startsWith('http') ? theme?.cashpointBackgroundImage : null;

  if (expiredJoodMembershipType && priceType === expiredJoodMembershipType) {
    userJoodMembershipType = priceType = expiredJoodMembershipType;
  }
  $: jooddayTheme = getJoodDayBannerDetails(userJoodMembershipType);
  $: cashpointBg = jooddayTheme?.cashpointBackgroundImage ? `url(${jooddayTheme.cashpointBackgroundImage})` : undefined;

  $: displayPrice = $pdpProductPrice?.tacticalVipPrimePrice ?? 0;
  $: wasPrice = $pdpProductPrice?.vipPrimePrice ?? 0;
  $: savedPrice = wasPrice > displayPrice ? wasPrice - displayPrice : 0;
  $: savedPercent = wasPrice > 0 ? roundToNDigits((savedPrice * 100) / wasPrice, 0) : 0;
  $: joodDayRemainingQuantity = $pdpProductPrice?.joodDayRemainingQuantity || 0;

  const joodSubscribeLinkHref = `${encodedContextPath}/jood/benefits`;

  $: joodSubscripeLinkLabel = getJoodSubscripeLinkLabel(variant, joodDayRemainingQuantity, savedPercent);
  const joodSubsLinkBundleWebLabel = getJoodSubsLinkBundleWebLabel();
  const joodCreditLabel = getjoodCreditLabel();

  // Utility Functions
  function getJoodSubscripeLinkLabel(variant, remainingQuantity, percent) {
    const variants = { pdp: 'pdp', 'plp-list': 'plp', qac: 'addtocart' };
    let output = '';
    if (userJoodMembershipType === NOPRIME && variant === 'pdp') {
      if (remainingQuantity) {
        output = `${getStr('extra.joodday.availble.qty.pdp', [remainingQuantity])} ${getStr('extra.jood.wallet.more.credit.pdp.noprime', [percent])}`;
      } else {
        output = getStr('extra.jood.wallet.more.credit.pdp.noprime', [percent]);
      }
    } else if (userJoodMembershipType !== NOPRIME && variant === 'pdp') {
      if (remainingQuantity) {
        output = `${getStr('extra.joodday.availble.qty.pdp', [remainingQuantity])} ${getStr('extra.jood.wallet.more.credit.pdp.prime', [percent])}`;
      } else {
        output = getStr('extra.jood.wallet.more.credit.pdp.prime', [percent]);
      }
    } else {
      output = getStr(`extra.jood.wallet.jood.subscription.link.${variants[variant] || 'all'}`);
    }
    return output;
  }

  function getJoodSubsLinkBundleWebLabel() {
    if (userJoodMembershipType === NOPRIME) {
      return getStr(`extra.jood.wallet.jood.subscription.link.bundle.noprime`);
    } else {
      return getStr(`extra.jood.wallet.jood.subscription.link.bundle`);
    }
  }

  function getjoodCreditLabel() {
    const types = { VIPPRIME: 'gold', BASICPRIME: 'blue', SMARTPRIME: 'smart' };
    if (variant === 'pdp-services') {
      return getStr('extra.jood.wallet.service.credits');
    } else {
      return getStr(`extra.jood.wallet.jood.credits.${types[userJoodMembershipType] || 'noprime'}`);
    }
  }
  function openJoodBenefitModal() {
    if ($pdpJoodBenefitInfo === null) {
      getpdpJoodBenefitInfo();
    }
    $openPdpJoodBenefitInfoPopup = true;
  }
</script>

<section
  class="{variant === 'pdp-popup'
    ? ' variant-pdp '
    : ''} c_middle-jood-credits-details variant-{variant} jood-{priceType} {primeLevel ? 'user-PRIME' : 'user-NOPRIME'}"
>
  <div class="credits-details-left" style:background-image={isTacticalFlag ? cashpointBg : bgImage}>
    <img class="img" src={`${extraThemeResourcePath}/images/jood/jood_credit_icon.svg`} alt="Jood Card" />
    <span class="price" style:color={isTacticalFlag ? theme?.priceColor : undefined}>
      {@html getStr('jood.price.with.currency', [globalCurrencyTag, creditPoints])}
    </span>
    <span class="text" style:color={isTacticalFlag ? theme?.shortDescriptionColor : undefined}>{joodCreditLabel}</span>
  </div>
  {#if userJoodMembershipType === NOPRIME && !joodExpiredFlag && variant !== 'pdp-services' && variant !== 'bundle-tile'}
    <div class="credits-details-right">
      <a
        href={variant !== 'pdp' ? joodSubscribeLinkHref : 'javascript:void(0);'}
        on:click={e => {
          e.stopPropagation();
          if (variant === 'pdp') {
            e.preventDefault();
            openJoodBenefitModal();
          }
        }}
      >
        <span
          class="text"
          style={isTacticalFlag && bgImage ? `color: ${jooddayTheme?.moreCashpointTextColor};` : undefined}
          >{joodSubscripeLinkLabel}</span
        >
        <span
          class="c_icon_new {lang === 'en' ? 'c_icon_new--chevron_right' : 'c_icon_new--chevron_left'}"
          style={isTacticalFlag && bgImage ? `color: ${jooddayTheme?.moreCashpointTextColor};` : undefined}
        ></span>
      </a>
    </div>
  {/if}

  {#if variant === 'bundle-tile'}
    <div class="credits-details-right">
      <a href={joodSubscribeLinkHref}>
        <span class="text">{joodSubsLinkBundleWebLabel}</span>
      </a>
    </div>
  {/if}
  {#if priceType !== NOPRIME && variant !== 'pdp-services'}
    <JoodExpireWallet {variant} place="price-expire-card" />
  {/if}
</section>

<style lang="scss">
  @import '../../../../common/styles/colors.new.scss';

  .c_middle-jood-credits-details {
    white-space: nowrap;
    &.variant-plp-grid {
      .credits-details-left {
        background-size: cover;
        width: max-content;
        .price {
          :global {
            .price {
              font-size: 10px;
            }
          }
        }
      }
    }
  }

  .credits-details-left {
    background-size: cover;
  }

  .credits-details-left img.img {
    height: 24px !important;
    @include responsive {
      height: 16px !important;
    }
  }
  :global {
    .c_middle-jood-credits-details.variant-plp-list .credits-details-left img.img,
    .c_middle-jood-credits-details.variant-qac .credits-details-left img.img {
      height: 22px !important;
      width: 22px !important;
    }
  }
</style>
